import React from "react";
// Import css files


const Banner = () => {

    // opens menu
    function openMenu() {
        document.body.classList += " menu--open";
    }

    // closes menu
    function closeMenu() {
        document.body.classList.remove("menu--open");
    }

    // const settings = {
    //     infinite: true,
    //     autoplay: true,
    //     autoplayspeed: 2000,
    //     speed: 2000,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    // };

    return (
        <>
            {/* Slider */}
            {/* <Slider {...settings} > */}
            <div className="coupon-container">
                {/* <p className="title-coupon">Black Friday Sale</p> */}
                <p className="promo-title">Not Selling anything</p>
                {/* <p><b>30% OFF YOUR PURCHASE</b></p>
                <p className="promo-title">
                    Use Promo Code: 
                    <span className="promo">BIKESHOP35H</span> 
                    <a href="/bikes">Learn more</a> 
                </p> */}
            </div>
            {/* <p className="expire"><Countdown /></p> */}
            {/* </Slider> */}
            {/* Slider */}
        </>
    );
};

export default Banner;